import { render, staticRenderFns } from "./OrderItemRefundStatus.vue?vue&type=template&id=0224aa2b&scoped=true"
import script from "./OrderItemRefundStatus.vue?vue&type=script&lang=js"
export * from "./OrderItemRefundStatus.vue?vue&type=script&lang=js"
import style0 from "./OrderItemRefundStatus.vue?vue&type=style&index=0&id=0224aa2b&scoped=true&lang=css"
import style1 from "./OrderItemRefundStatus.vue?vue&type=style&index=1&id=0224aa2b&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0224aa2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0224aa2b')) {
      api.createRecord('0224aa2b', component.options)
    } else {
      api.reload('0224aa2b', component.options)
    }
    module.hot.accept("./OrderItemRefundStatus.vue?vue&type=template&id=0224aa2b&scoped=true", function () {
      api.rerender('0224aa2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OrderItemRefundStatus.vue"
export default component.exports